import {Injectable} from '@angular/core';
import {HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {HttpService} from 'src/app/services/http.service';
import {
  AccessRequestResponse,
  AddAgencyRepResponse,
  ProtestListForIntervenorResponse,
  ProtestRequestResponse,
  ProtestResponse,
  TransactionStatus,
  UserModel,
  validateProtestInfoResponse
} from '../models/protest';


@Injectable({
  providedIn: 'root'
})
export class ProtestInfoService {
  aNum: string = '';

  constructor(private readonly httpService: HttpService) {
  }

  getProtestResponse(): Observable<ProtestResponse> {
    let request = new HttpParams()
      .set('typeOfProtest', 'protest')
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    const options = {...headers};
    return this.httpService.Get<ProtestResponse>('/protest-request?' + request.toString(), options);
  }

  validateProtestInfo(request: FormData): Observable<validateProtestInfoResponse> {
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    const options = {...headers};
    return this.httpService.Post<validateProtestInfoResponse>('/validate-protest?', request, options);
  }

  registerNewProtestInfo(request: FormData): Observable<UserModel> {
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    const options = {...headers};
    return this.httpService.Post<UserModel>('/register-protest?', request, options);
  }

  payGovCollection(a_Num: string): Observable<any> {
    const formData = new FormData();
    formData.append('a_No', a_Num);
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    const options = {...headers};
    return this.httpService.Post<any>('/startPayDotGovOnlineCollection?', formData, options);
  }

  testPayGov(): Observable<any> {
    const currentTimeAsInt = Date.now();
    const headers = new HttpHeaders({'Accept': 'application/json,text/javascript'});
    const options = {headers};
    return this.httpService.Post<any>(`/testPayDotGov?cacheBuster=${currentTimeAsInt}`,null, options);
  }

  checkTransactionStatus(a_Num: string, token: string): Observable<TransactionStatus> {
    const currentTimeAsInt = Date.now();
    const headers = new HttpHeaders({'Accept': 'application/json,text/javascript'});
    const options = {headers};
    return this.httpService.Get<TransactionStatus>(`/check-transaction-status?cacheBuster=${currentTimeAsInt}&a_Num=${a_Num}&token=${token}`, options);
  }

  setA_Num(aNum: string): void {
    this.aNum = aNum;
  }

  getA_Num(): string {
    return this.aNum;
  }

  protestRequest(aNum: string, typeOfProtest: string) {
    const options = { headers: this.httpService.jsonHeaders };
    const url = '/protest-request?protestId=' + aNum + '&typeOfProtest=' + typeOfProtest;

    return this.httpService.Get<ProtestRequestResponse>(url, options);
  }

  registerOtherProtests(a_No: string, typeOfProtest: string, isDocConfidential: string|undefined, comments: string|undefined, filerId: number, agencyName: string|undefined, companyName: string|undefined) {
    const formData = {
      protestId : a_No,
      typeOfProtest,
      filerId,
      isDocConfidential,
      company_name: agencyName || companyName,
    }

    const httpParams =  this.httpService.createHttpParams(formData);
    const options = { headers: this.httpService.formHeaders };
    const url = '/register-protest';

    return this.httpService.Post<any>(url, httpParams, options);
  }


  requestToCaseAccess() {
    const options = { headers: this.httpService.jsonHeaders };
    const url = '/request-to-case-access';

    return this.httpService.Get<AccessRequestResponse>(url, options);
  }

  getListOfProtestsForIntervenor(bNo: string) {
    const formData = {
      bNo
    }

    const httpParams =  this.httpService.createHttpParams(formData);
    const options = { headers: this.httpService.formHeaders };
    const url = '/get-list-of-protests-for-intervenor-access';

    return this.httpService.Post<ProtestListForIntervenorResponse>(url, httpParams, options);
  }

  getListOfProtestsForAgencyRep(bNo: string) {
    const formData = {
      bNo
    }

    const httpParams =  this.httpService.createHttpParams(formData);
    const options = { headers: this.httpService.formHeaders };
    const url = '/get-list-of-protests-for-agency-rep-access';

    return this.httpService.Post<ProtestListForIntervenorResponse>(url, httpParams, options);
  }

  addAgencyRep(aNo: string, comments: string, requestType: string, typeOfDocument: string, docId: number, isDocConfidential: string) {
    const formData = {
      protestId: aNo,
      comments,
      requestType,
      typeOfDocument,
      docId,
      isDocConfidential
    }

    const httpParams =  this.httpService.createHttpParams(formData);
    const options = { headers: this.httpService.formHeaders };
    const url = '/add-attachments/agency-rep-request';

    return this.httpService.Post<AddAgencyRepResponse>(url, httpParams, options);
  }

}
